<template>
	<div class="identityOperatingRecord " >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-shenfenyanzheng- Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 身份&amp;安全 / 企业操作记录</span>
		</div>
		<div class="companyOperatingRecordBox content_Box box-shadow m-t-15" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<template>
				<el-table :data="tableData" stripe style="width: 100%">
					<el-table-column prop="name" label="操作人">
					</el-table-column>
					<el-table-column prop="date" label="操作时间">
					</el-table-column>
					<el-table-column prop="address" label="操作内容">
					</el-table-column>
				</el-table>
			</template>
		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'identityOperatingRecord',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}]
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //判断是否登录
					window.location = 'login.html';
					return;
				}
			},
		}
	}
</script>

<style scoped>
	/* .identityOperatingRecord {
		padding: 15px 15px 0 15px;
	} */
</style>



// WEBPACK FOOTER //
// src/components/IdentityOperatingRecord.vue